import { Input, Select, TextInput } from '@mantine/core';
import { IMaskInput } from 'react-imask';

import { BULLETIN_TYPE } from '@/types/enums';
import { BULLETIN_NUMBER_MASKS, BULLETIN_TYPE_OPTIONS } from '@/helpers';

const DISCOVER_MASS_ID_MIN_LENGTH = 4;
const DISCOVER_MASS_ID_MAX_LENGTH = 7;

type OrganizationBulletinFieldsProps = {
  discoverMassId: string;
  bulletinType: BULLETIN_TYPE;
  bulletinNumber: string;
  bulletinNumberError: string | null;
  showBulletinFields?: boolean;
  onDiscoverMassIdChange: (value: string) => void;
  onBulletinTypeChange: (value: string | null) => void;
  onBulletinNumberChange: (value: string) => void;
};

export const OrganizationBulletinFields = ({
  discoverMassId,
  bulletinType,
  bulletinNumber,
  bulletinNumberError,
  showBulletinFields = true,
  onDiscoverMassIdChange,
  onBulletinTypeChange,
  onBulletinNumberChange,
}: OrganizationBulletinFieldsProps) => {
  const trimmedDiscoverMassId = discoverMassId.trim();
  const isDiscoverMassIdInvalid =
    trimmedDiscoverMassId.length > 0 &&
    (trimmedDiscoverMassId.length < DISCOVER_MASS_ID_MIN_LENGTH ||
      trimmedDiscoverMassId.length > DISCOVER_MASS_ID_MAX_LENGTH);

  return (
    <>
      <TextInput
        label="Discover Mass ID"
        placeholder="Discover Mass ID"
        description={`Optional · ${DISCOVER_MASS_ID_MIN_LENGTH}–${DISCOVER_MASS_ID_MAX_LENGTH} characters if provided`}
        value={discoverMassId}
        onChange={(e) => onDiscoverMassIdChange(e.target.value)}
        error={
          isDiscoverMassIdInvalid
            ? `Must be ${DISCOVER_MASS_ID_MIN_LENGTH}–${DISCOVER_MASS_ID_MAX_LENGTH} characters`
            : undefined
        }
      />

      {showBulletinFields && (
        <>
          <Select
            label="Bulletin Type"
            data={BULLETIN_TYPE_OPTIONS}
            value={bulletinType}
            onChange={onBulletinTypeChange}
          />

          {bulletinType !== BULLETIN_TYPE.NONE && (
            <Input.Wrapper label="Bulletin Number" error={bulletinNumberError}>
              <Input
                value={bulletinNumber}
                component={IMaskInput}
                mask={BULLETIN_NUMBER_MASKS[bulletinType]}
                onChange={(e) => onBulletinNumberChange(e.currentTarget.value)}
                placeholder={
                  bulletinType === BULLETIN_TYPE.DIOCESAN
                    ? '####'
                    : bulletinType === BULLETIN_TYPE.LPI
                      ? '##-####'
                      : '######'
                }
              />
            </Input.Wrapper>
          )}
        </>
      )}
    </>
  );
};
